import { TableFilter } from '@app/components/common/table';


export const getArrayFilterValue = <T>(filter: TableFilter<T>[], name: string) => {
  const filterItem = filter.find(({ name: itemName }) => itemName === name);
  if (!filterItem) {return undefined;}
  const value = filterItem.value as EntityBase[];
  if (!value || value.length === 0) {return undefined;}
  return value.map(({ id }) => Number(id));
};

export const getFilterValue = <T, R = string>(filter: TableFilter<T>[], name: string) => {
  const filterItem = filter.find(({ name: itemName }) => itemName === name);
  if (!filterItem) {return undefined;}
  if ((filterItem.value as EntityBase)?.id)  {
    return (filterItem.value as EntityBase).id as R || undefined;
  }
  return filterItem.value as R || undefined;
};

